import { UniqueEntityId, WatchedList } from "@kernel/ddd";
import { Device, MediaDeviceOption } from "./Device";

export class DeviceList extends WatchedList<Device> {
  public getOptions(kind?: MediaDeviceKind): MediaDeviceOption[] {
    if (kind) {
      return this.getItems()
        .filter((device) => device.isKind(kind))
        .map((device) => device.toOption());
    }
    return this.getItems().map((device) => device.toOption());
  }

  public getDeviceById(id: string): Device | null {
    return this.getById(new UniqueEntityId(id));
  }

  public getDefaultAudioDevice(): Device | null {
    const items = this.getItems().filter((device) => device.isAudioInput());
    if (items.length > 0) {
      return items[0];
    }
    return null;
  }

  public getDefaultVideoDevice(): Device | null {
    const items = this.getItems().filter((device) => device.isVideoInput());
    if (items.length > 0) {
      return items[0];
    }
    return null;
  }

  public getVideoDevices(): DeviceList {
    return new DeviceList(
      this.getItems().filter((device) => device.isVideoInput())
    );
  }

  public getAudioInputDevices(): DeviceList {
    return new DeviceList(
      this.getItems().filter((device) => device.isAudioInput())
    );
  }

  public getAudioOutputDevices(): DeviceList {
    return new DeviceList(
      this.getItems().filter((device) => device.isAudioOutput())
    );
  }

  public compareItems(a: Device, b: Device): boolean {
    return a.equals(b);
  }

  public static create(initialDevices?: Device[]): DeviceList {
    return new DeviceList(initialDevices ? initialDevices : []);
  }
}
